module.exports = __webpack_public_path__ + "img/0496ef1.jpg";